<template>
  <div>
    <div v-if="canViewPage">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Đơn đăng ký đồng phục"
            :link="[
              {
                text: 'Đơn đăng ký đồng phục',
                href: './uniform-orders-register',
              },
            ]"
          />
        </div>
        <div>
          <div class="d-flex align-center gap-4 mb-2" style="justify-self: right" v-if="!canDisplayByStudent">
            <div class="uniform-status" @mouseover="showHistory = true" @mouseleave="showHistory = false">
              {{ statusText }}
              <div class="history-dropdown">
                <v-list v-if="showHistory && uniformConfig.history && uniformConfig.history.length">
                  <v-list-item v-for="(item, index) in uniformConfig.history" :key="index">
                    <v-list-item-content>
                      <v-list-item-title> {{ item.user.name }} - {{ item.action }} </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ item.timestamp }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </div>

            <v-btn
              class="ml-5"
              outlined
              :color="uniformConfig.isOpen ? 'error' : 'success'"
              @click="toggleRegistration"
            >
              <v-icon left>{{ uniformConfig.isOpen ? 'mdi-lock' : 'mdi-lock-open' }}</v-icon>
              {{ uniformConfig.isOpen ? 'Đóng đăng ký' : 'Mở đăng ký' }}
            </v-btn>
          </div>
          <div style="justify-self: right">
            <v-btn
              v-if="$vuetify.breakpoint.mdAndUp && !canDisplayByStudent"
              outlined
              color="warning"
              @click="showSizeChartDialog = true"
            >
              <v-icon left>mdi-file-image</v-icon> Bảng quy đổi kích cỡ
            </v-btn>
            <UniformSizeChartDialog :state="showSizeChartDialog" @update:state="showSizeChartDialog = $event" />
            <v-btn
              depressed
              dark
              color="primary"
              @click="newDialog = !newDialog"
              class="ml-5"
              v-if="!hasOrderThisMonth"
            >
              <v-icon>mdi-plus</v-icon> Tạo đơn đăng ký đồng phục
            </v-btn>
          </div>
          <div style="justify-self: right" class="mt-2" v-if="!canDisplayByStudent">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="success" v-bind="attrs" v-on="on" outlined>
                  <v-icon left>mdi-file-excel</v-icon> Xuất Excel
                  <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="exportExcel">
                  <v-list-item-content>
                    <v-list-item-title>Xuất Theo Đơn ĐK</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="exportExcelByUniform">
                  <v-list-item-content>
                    <v-list-item-title>Xuất Theo Mặt Hàng</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>

      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <UniformOrdersRegisterFilter @onFilterChanged="onFilterChange" />
      </v-card>

      <v-card outlined class="mx-4 elevation-0">
        <UniformOrdersRegisterTable ref="table" />
      </v-card>
      <UniformOrderNewDialog :state="newDialog" @updated="onFilterChange()" />
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import utils from '@/plugins/utils'
import { UniformOrders } from '@/plugins/api'
import UniformOrdersRegisterTable from '@/modules/uniformOrdersRegister/UniformOrdersRegisterTable.vue'
import UniformOrdersRegisterFilter from '@/modules/uniformOrdersRegister/UniformOrdersRegisterFilter.vue'
import UniformSizeChartDialog from '@/views/uniformOrdersRegister/UniformSizeChartDialog.vue'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

export default {
  components: {
    Breadcrumbs,
    UniformOrdersRegisterTable,
    UniformOrdersRegisterFilter,
    UniformSizeChartDialog,
    UniformOrderNewDialog: () => import('@/modules/uniformOrdersRegister/UniformOrderNewDialog.vue'),
  },
  props: {},
  data() {
    return {
      showSizeChartDialog: false,
      newDialog: false,
      type: '',
      showHistory: false,
      advancedExcel: false,
    }
  },
  computed: {
    ...mapState('UniformOrdersRegister', ['uniformConfig', 'uniformOrdersSearchParams', 'date']),

    canViewPage() {
      return this.$auth.policies['uniform-orders-list'] || get(this.$auth.user, 'role.type') === 'student'
    },
    canDisplayByStudent() {
      return get(this.$auth.user, 'role.type') === 'student'
    },
    statusText() {
      if (!this.uniformConfig.history || !this.uniformConfig.history.length) {
        return 'Chưa có lịch sử cấu hình'
      }
      // const lastAction = this.uniformConfig.history[this.uniformConfig.history.length - 1]
      const lastAction = this.uniformConfig.history[0]
      return `${lastAction.action} lần cuối vào ${lastAction.timestamp}`
    },
    hasOrderThisMonth() {
      if (!this.canDisplayByStudent) return false

      const now = new Date()
      const currentMonth = now.getMonth() + 1
      const currentYear = now.getFullYear()

      const orders = this.$store.state.UniformOrdersRegister.uniformOrderss || []
      return orders.some(order => {
        if (!order.orderedAt || (order.status !== 'pending' && order.status !== 'confirmed')) return false

        // orderedAt dạng '27/05/2025, 15:45'
        const datePart = order.orderedAt.split(',')[0] // '27/05/2025'
        const [day, month, year] = datePart.split('/')

        return parseInt(month) === currentMonth && parseInt(year) === currentYear
      })
    },
  },
  methods: {
    ...mapActions('UniformOrdersRegister', ['setDate', 'fetchUniformConfig', 'toggleRegistrationStatus']),

    async toggleRegistration() {
      await this.toggleRegistrationStatus()
    },
    async refresh(query) {
      this.$refs.table.refresh(query)
    },
    onFilterChange(query) {
      if (get(query, 'fromDate') && get(query, 'toDate')) {
        this.setDate({ fromDate: query.fromDate, toDate: query.toDate })
      }
      this.refresh(query)
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        const list = await UniformOrders.getUniformOrdersRegisterByStudents(this.uniformOrdersSearchParams)
        const uniformOrderss = JSON.parse(JSON.stringify(list))
        const filters = this.$options.filters

        const hasOptionTwo = uniformOrderss.some(order =>
          (order.uniformItems || []).some(item => item.optionTwo && item.optionTwo.trim() !== '')
        )

        const headers = [
          { text: 'Học sinh', value: 'student' },
          { text: 'Mã số', value: 'code' },
          { text: 'Ngày sinh', value: 'dob' },
          { text: 'Giới tính', value: 'gender' },
          { text: 'Lớp', value: 'class' },
          { text: 'Tên đồng phục', value: 'uniformName' },
          { text: 'Phân loại 1', value: 'optionOne' },
          ...(hasOptionTwo ? [{ text: 'Phân loại 2', value: 'optionTwo' }] : []),
          { text: 'Ghi chú của phụ huynh', value: 'note' },
          { text: 'Số lượng', value: 'quantity' },
          { text: 'Đã trả', value: 'returned' },
          { text: 'Ngày đặt hàng', value: 'orderedAt' },
          { text: 'Tổng tiền', value: 'totalPrice' },
          { text: 'Trạng thái đơn', value: 'status' },
          { text: 'Trạng thái trả', value: 'statusReturned' },
        ]

        const groupedData = uniformOrderss.map(order => {
          const base = {
            student: order.student.name,
            code: order.student.code,
            dob: filters.ddmmyyyy(order.student.dob),
            gender: filters.gender(order.student.gender),
            class: get(order, 'student.class.title', ''),
            status: this.getStatusText(order.status),
            statusReturned: this.getStatusReturnText(order.statusReturned),
            note: order.note,
            totalPrice: order.totalPrice,
            orderedAt: order.orderedAt,
          }

          const items = (order.uniformItems || []).map(uni => ({
            uniformName: uni.name,
            optionOne: uni.optionOne,
            ...(hasOptionTwo ? { optionTwo: uni.optionTwo || '' } : {}),
            quantity: uni.quantity,
            returned: uni.returned || 0,
          }))

          return {
            ...base,
            items: items.length > 0 ? items : [{}],
          }
        })

        const date = new Date().toLocaleDateString('vi-VN').replaceAll('/', '-')

        utils.exportExcelWithMerge(groupedData, headers, `${date}_DSDangKyDongPhuc`, {
          mergeFields: [
            'student',
            'code',
            'dob',
            'gender',
            'class',
            'status',
            'statusReturned',
            'note',
            'totalPrice',
            'orderedAt',
          ],
        })
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    async exportExcelByUniform() {
      this.$loading.active = true
      try {
        const list = await UniformOrders.getUniformOrdersRegisterByStudents(this.uniformOrdersSearchParams)
        const uniformOrderss = JSON.parse(JSON.stringify(list))

        // Kiểm tra có cần hiển thị optionTwo không
        const hasOptionTwo = uniformOrderss.some(order =>
          (order.uniformItems || []).some(item => item.optionTwo && item.optionTwo.trim() !== '')
        )

        // Header
        const headers = [
          { text: 'Tên đồng phục', value: 'uniformName' },
          { text: 'Phân loại 1', value: 'optionOne' },
          ...(hasOptionTwo ? [{ text: 'Phân loại 2', value: 'optionTwo' }] : []),
          { text: 'Số lượng đặt', value: 'quantity' },
          { text: 'Số lượng đã trả', value: 'returned' },
        ]

        // Flatten và group mặt hàng
        const itemMap = new Map()

        uniformOrderss.forEach(order => {
          const items = order.uniformItems || []
          items.forEach(uni => {
            const key = [uni.name, uni.optionOne, hasOptionTwo ? uni.optionTwo || '' : ''].join('||')

            if (!itemMap.has(key)) {
              itemMap.set(key, {
                uniformName: uni.name,
                optionOne: uni.optionOne,
                ...(hasOptionTwo ? { optionTwo: uni.optionTwo || '' } : {}),
                quantity: 0,
                returned: 0,
              })
            }

            const entry = itemMap.get(key)
            entry.quantity += uni.quantity
            entry.returned += uni.returned || 0
          })
        })

        const groupedItems = Array.from(itemMap.values())

        const date = new Date().toLocaleDateString('vi-VN').replaceAll('/', '-')
        utils.exportExcel(groupedItems, headers, `${date}_ThongKeMatHangDongPhuc`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    getStatusText(status) {
      return (
        {
          pending: 'Chờ duyệt',
          confirmed: 'Đã xác nhận',
          cancelled: 'Đã hủy',
        }[status] || 'Không xác định'
      )
    },
    getStatusReturnText(statusReturned) {
      return (
        {
          not_returned: 'Chưa trả',
          waiting_returned: 'Đang trả hàng',
          complete_returned: 'Đã hoàn thành',
        }[statusReturned] || 'Không xác định'
      )
    },
  },
  async created() {
    await this.fetchUniformConfig()
  },
}
</script>
<style scoped>
.uniform-status {
  position: relative;
  display: inline-block;
  cursor: pointer;
  font-weight: normal;
  transition: color 0.3s ease;
}
.history-dropdown {
  position: absolute;
  top: 30px; /* Ngay dưới dòng status */
  left: 0;
  z-index: 10;
  width: 300px;
  background-color: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  overflow: hidden;
}
.history-dropdown v-list {
  max-height: 250px;
  overflow-y: auto;
}

.v-list-item {
  cursor: default;
}

.v-list-item:hover {
  background-color: #f9f9f9;
}
</style>
